export default __webpack_public_path__ + "static/media/phone.041e344f.svg";